import useRouteMatch from "@Routing/hooks/useRouteMatch";
import {useAppSelector} from "@Hooks/selector/useAppSelector";
import useIsMobile from "@Hooks/selector/useIsMobile";
import useSearchResultsCount from "@SearchResults/hooks/useSearchResultsCount";

export default function useDisplayEditButton() {
    const isMobile = useIsMobile()
    const additionalInfoActive = useRouteMatch('additionalInfo')
    const returnAdditionalInfoActive = useRouteMatch('returnAdditionalInfo')
    const isSearch = useRouteMatch('searchResults')
    const {mobileOverlayActive} = useAppSelector((state) => state.mobile)
    const totalRoutesCount = useSearchResultsCount()

    return (isMobile) && isSearch && (!additionalInfoActive && !returnAdditionalInfoActive && !mobileOverlayActive) && totalRoutesCount !== 0
}